// What one visit records for the site's own counter (backend/visits.py):
// the referring site's host (never the full address), the landing link's
// utm_* tags, whether X added its ad-click id (not the id itself), the
// storm in a shared link, and the kind of device.

export type Device = "phone" | "tablet" | "desktop";

export interface VisitInfo {
  d: Device;
  r?: string; // referring host
  us?: string; // utm_source
  um?: string; // utm_medium
  uc?: string; // utm_campaign
  s?: string; // storm id from a shared link
  x?: true; // X ad click (twclid on the link)
}

/** Touch screens under 600 px on their short side are phones. */
export function deviceClass(coarsePointer: boolean, shortSide: number): Device {
  if (!coarsePointer) return "desktop";
  return shortSide < 600 ? "phone" : "tablet";
}

export function visitInfo(referrer: string, search: string, hash: string, device: Device): VisitInfo {
  const info: VisitInfo = { d: device };
  try {
    if (referrer) info.r = new URL(referrer).hostname;
  } catch {
    // an unparseable referrer counts as none
  }
  const q = new URLSearchParams(search);
  const tags = [["us", "utm_source"], ["um", "utm_medium"], ["uc", "utm_campaign"]] as const;
  for (const [key, param] of tags) {
    const v = q.get(param);
    if (v) info[key] = v;
  }
  if (q.has("twclid")) info.x = true;
  const storm = new URLSearchParams(hash.replace(/^#/, "")).get("lv");
  if (storm) info.s = storm;
  return info;
}
